import { useLocation } from "react-router-dom";
import { isExploreSandboxPath } from "../lib/exploreSandbox";

export function useExploreSandbox(): boolean {
  const { pathname } = useLocation();
  return isExploreSandboxPath(pathname);
}
